import React from "react";
import { Routes, Route } from "react-router-dom";
import './i18n'; // Importa la configurazione i18n
import Home from "./pages/Home";
import AboutUs from "./pages/AboutUs";
import Projects from "./pages/Projects";
import Services from "./pages/Services";
import Contact from "./pages/Contact";
import Admin from "./pages/Admin";
import Login from "./pages/Login";
import StudioPastore from "./pages/StudioPastore";
import PrivateRoute from "./components/auth/PrivateRoute";


function App() {
  return (
    <div className="d-flex flex-column min-vh-100">
      <main className="flex-grow-1">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about-us" element={<AboutUs />} />
          <Route path="/progetti" element={<Projects />} />
          <Route path="/servizi" element={<Services />} />
          <Route path="/contatti" element={<Contact />} />
          <Route path="/login" element={<Login />} />
          <Route path="/admin-access" element={<Login />} />
          <Route path="/StudioPastore" element={<StudioPastore />} />

          <Route
            path="/admin/*"
            element={
              <PrivateRoute>
                <Admin />
              </PrivateRoute>
            }
          />
        </Routes>
      </main>
    </div>
  );
}

export default App;
